import { Note, NoteType } from '@/@types/note';

export type NoteApiResponse = {
  id: number;
  title: string;
  content: string;
  type: NoteType;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
};

function formatNoteDate(value: string | null, longMonth = false) {
  if (!value) return null;

  return new Date(value).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: longMonth ? 'long' : '2-digit',
    year: 'numeric',
    hour: longMonth ? undefined : '2-digit',
    minute: longMonth ? undefined : '2-digit',
  });
}

export function transformNoteToFrontend(note: NoteApiResponse): Note {
  return {
    id: note.id,
    title: note.title,
    content: note.content,
    type: note.type,
    createdAt: formatNoteDate(note.created_at) || '',
    updatedAt: formatNoteDate(note.updated_at) || '',
    deletedAt: formatNoteDate(note.deleted_at, true),
  };
}
